// extracted by mini-css-extract-plugin
export default {"saveButton":"app-portainer-settings-edge-compute-SettingsOpenAMT-SettingsOpenAMT-module__save-button"};